<template>
  <div class="pl-5 pr-5">
    <p style="text-align: center; font-weight: 600; font-size: 18px;" class="mb-0 pt-4">{{ text }}</p>
    <p style="text-align: center;">{{ $t('PasswordToConfirm') }}</p>

    <div style="text-align: center;">
      <input v-model="pwd" type="password" :placeholder="$t('NewPassword')">
    </div>
    <div class="error" v-if="error != ''" style="margin-left: 10px;">{{ error }}</div>
    <div class="row d-flex justify-content-between pb-4 mt-4 ml-4 mr-4">
      <div class="col flex-grow pr-2">
        <Button :title="$t('Cancel')" buttonClass='cancel-button semi-bold w-100' @onClick="cancel" />
      </div>
      <div class="col flex-grow pl-2">
        <Button :title="$t('Confirm')" buttonClass='save-button semi-bold w-100' @onClick="confirm" />
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button'
import { restorePassword } from '../../api/api';

export default {
    props: ['text', 'email'],
    data: function () {
        return {
            pwd: '',
            error: ''
        }
    },
    methods: {
        async confirm() {
            this.error = '';

            if (this.pwd == null || this.pwd.length == 0) {
                this.error = 'Required';
            } else {
                this.error = '';
                try {
                    await restorePassword({Email: this.email.email, NewPassword: this.pwd, OldPassword: this.pwd, ConfirmNewPassword: this.pwd })
                    this.$emit('confirm')
                } catch (ex) {
                    // console.log({ex})
                    let err = ex.response.data.errors
                    this.error = ''
                    Object.keys(err).forEach(e => {
                        err[e].forEach(el => {
                            this.error += el + '\n'
                        })
                    })
                }
            }
        },
        cancel() {
            this.$emit('cancel');
        }
    },
    computed: {},
    components: {
        Button
    },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Users/RestorePasswordModal.vue